import React from 'react';
import PropTypes from 'prop-types';
import "./index.css";

ImageButton.propTypes = {
    image: PropTypes.object.isRequired,
    text: PropTypes.string.isRequired,
    action: PropTypes.func.isRequired,
};

function ImageButton(props) {
    return (
        <div onClick={props.action} className="image-btn-container">
            <img alt={props.text} {...props.image}/>
            <div className="image-btn-text">{props.text}</div>
        </div>
    );
}

export default ImageButton;